<template>
    <!-- 菜单悬浮窗展开二三级 -->
    <ul v-show='visible' class="menu-popver" :class="{'menu-popver-col': isCollapse}" :style="{minHeight: minHeight}">
        <li class="level2-content">
            <div v-for="(item) in menuData.subNodes" :key="item.fdId" class="level3-content" @click="goRouter(item.fdFrontLink, item)">
                <span class="level3-tilte">{{ item.fdName }}</span>
            </div>
        </li>
    </ul>
</template>

<script>

export default {
    name: 'MenuPopver',
    props: {
        menuData: {
            type: Object,
        },
        isCollapse: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
            minHeight: '380px',
        };
    },
    computed: {

    },
    methods: {
        showPopover(index) {
            // 二级菜单内容少，一级菜单位置较后时，minHeight需要动态调大，否则会出现选不到二级菜单的情况
            if (index > 5) {
                this.minHeight = `${(index + 1) * 48}px`;
            }
            // 兼容分辨率很低的情况，最小高度大于屏幕高度时，设置最小高度为屏幕高度
            if (this.minHeight.replace('px', '') > window.innerHeight - 102) {
                this.minHeight = `${window.innerHeight - 110}px`;
            }
            this.visible = true;
        },
        closePopover() {
            this.visible = false;
        },
        // 点击菜单
        goRouter(link, item) {
            this.closePopover();
            this.$emit('goRouter', link, item);
        },
    },
};
</script>
<style scoped lang="less">
@import url("../../../../../styles/vars.less");
.menu-popver-col {
    left: @leftSidebar-width-col - 7px !important;
}
.menu-popver {
    position: fixed;
    left: @leftSidebar-width - 25px;
    top: @header-height*2 + 10px;
    width: auto;
    overflow-y: auto;
    overflow-x: auto;
    max-width: 82vw;
    min-width: 300px;
    max-height: 70vh;
    z-index: 1111;
    background-color: #FFFFFF;
    color: #000000;
    box-shadow: 1px 2px 5px 3px rgba(0,21,41,0.06);
    // padding: 29px 0 0 50px;
    display: flex;
    flex-wrap: wrap;
    // flex-direction: column;
    writing-mode: vertical-lr; // 解决换行元素无法撑开父盒子宽度问题
    .level2-content {
        writing-mode: horizontal-tb; // 解决换行元素无法撑开父盒子宽度问题
        margin-top: 30px;
        margin-left: 40px;
        width: 160px;
        .level2-tilte {
            font-weight: 500;
            font-size: 14px;
            color: @default-blue;
            margin-bottom: 20px;
            display: inline-block
        }
        }
        .level3-content {
            margin-bottom: 16px;
            font-size: 13px;
            font-weight: 400;
            color: #212B36;
            cursor: pointer;
            &:hover {
                color: @default-blue;
            }
        }

}
</style>
